import { IOperationHandler } from '@ms/items-view/lib/private/store/actions/implementOperation';
import { spItemPageKeyFacet, spFolderItemSetKeyFacet } from '../../../dataSource/Keys';
import { getItemsOperation } from '@ms/items-view/lib/private/operations/getItemsOperation';
import {
  createSingleItemOperationHandler,
  ISingleOperationPayload,
  IOperationHandlerThunkAction
} from '@ms/items-view/lib/private/addons/registerOperationHandler';
import { IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { getContentTypes, constructGetItemSetContext } from '../../../dataSource/getServerDataContext';
import { getServerData } from '../../../dataSource/getServerData';
import { processResponse } from '../../../dataSource/processResponse';
import { resolveExistingPage } from '@ms/items-view/lib/private/models/items/PageHelpers';

export const spItemPageGetItemsOperationHandler:
  IOperationHandler<typeof spItemPageKeyFacet.type, typeof getItemsOperation.type> =
  createSingleItemOperationHandler({
    maxParallelOperationCount: 8
  })(getSPItemPage);

function getSPItemPage(
  payload: ISingleOperationPayload<typeof spItemPageKeyFacet.type, typeof getItemsOperation.type>
): IOperationHandlerThunkAction {
  const {
    itemSetKey,
    token
  } = spItemPageKeyFacet.deserialize(payload.itemKey);

  return async (dispatch: IItemCacheDispatch) => {
    // TODO: add this back after DetailsList supports paging correctly
    // if (payload.options.demands[childItemsFacet.id]) {

    const serializedItemSetKey = spFolderItemSetKeyFacet.serialize(itemSetKey);

    const contentTypes = dispatch(getContentTypes({ itemSetKey }));
    const getItemContext = await dispatch(constructGetItemSetContext({
      itemSetKey: itemSetKey,
      contentTypes: contentTypes,
      pageToken: token,
      qosName: 'getSPItemNextPage'
    }));

    const serverData = await dispatch(getServerData(getItemContext));

    const {
      itemResolver,
      childKeys
    } = dispatch(processResponse({
      serverData,
      itemSetKey,
      currentPageContext: getItemContext.currentPageContext,
      contentTypes,
      isItemSetRequest: true
    }));

    itemResolver.merge(resolveExistingPage({
      itemKey: payload.itemKey,
      itemSetKey: serializedItemSetKey,
      childItemKeys: childKeys
    }).itemResolver);

    dispatch(itemResolver.execute());
  };
}
